// extracted by mini-css-extract-plugin
module.exports = {"app__footer":"y_bQ","app__footer__copyFoot":"y_bR"};